import { jsx as C } from "react/jsx-runtime";
import { usePlatformUi as p } from "@instructure/platform-provider";
import { IconButton as w } from "@instructure/ui-buttons";
import { SVGIcon as B } from "@instructure/ui-svg-images";
function A(n) {
  return /^https?:\/\//i.test(n) ? n : `https://${n}`;
}
function b(n) {
  return n ? {
    lmsDomain: n.location.host || void 0,
    lmsPathname: n.location.pathname || void 0
  } : {};
}
function g(n, e, i, t, o, l, r) {
  const a = new URLSearchParams();
  return i && a.set("lmsSource", i), n && a.set("lmsPathname", n), e && a.set("lmsDomain", e), t && a.set("lmsUserId", t), typeof o == "boolean" && a.set("lmsHasAthenaUser", String(o)), l && a.set("locale", l), r && a.set("timezone", r), a.toString();
}
function M(n, e, i) {
  const t = new URL(A(n));
  return t.pathname = e, t.search = i, t.toString();
}
const U = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.10344 2.7166C6.86715 2.63206 7.13939 3.71959 6.46882 4.01189C5.48302 4.44174 5.06606 2.83122 6.10344 2.7166Z" fill="#3B0764"/>
<path d="M13.7376 2.71659C14.6805 2.61343 14.7621 4.03625 13.8609 4.0821C12.9596 4.12795 12.888 2.80973 13.7376 2.71659Z" fill="#3B0764"/>
<path d="M11.4064 15.5348C11.6729 14.8714 11.928 14.198 12.0626 13.4916C11.256 13.228 10.882 12.3181 11.3104 11.5702C11.713 10.8695 12.6687 10.7061 13.2978 11.2191C14.2592 12.0043 13.6574 13.5847 12.4252 13.5446L12.3764 13.5991C12.2718 14.0404 12.1544 14.4817 12.001 14.9087C11.9265 15.115 11.6786 15.5721 11.6543 15.7326C11.6428 15.8056 11.9366 16.2269 11.9924 16.3774C12.7347 18.3561 10.3504 19.9695 8.77713 18.5954C7.27408 17.2815 8.48196 14.7754 10.4865 15.1322C10.8462 15.1967 11.0998 15.3572 11.4064 15.5363V15.5348Z" fill="#3B0764"/>
<path d="M14.2993 9.75187C14.8839 10.229 15.3826 10.8322 15.8081 11.4598C15.9987 11.4742 16.1764 11.4283 16.3741 11.4426C18.605 11.6002 18.8859 14.8184 16.7624 15.3715C14.2922 16.0148 13.1803 12.5287 15.4972 11.5616C15.1003 10.9698 14.5902 10.4769 14.0887 9.97826C13.9311 10.0384 13.8064 10.1588 13.6402 10.2204C12.5527 10.6173 11.5296 9.59999 11.9294 8.50959C12.4252 7.15842 14.6375 7.52379 14.4655 9.18876C14.444 9.39652 14.3251 9.55127 14.2993 9.75187Z" fill="#3B0764"/>
<path d="M8.58656 4.4618C8.32005 5.12521 8.06501 5.79865 7.93032 6.50504C9.05224 6.85466 9.20125 8.41789 8.13522 8.94518C6.40147 9.80202 5.27525 6.91484 7.33999 6.46492C7.43885 6.44343 7.56924 6.49501 7.61796 6.39901C7.79133 5.65393 8.01056 4.91458 8.36877 4.23828C7.35861 3.05618 7.96041 1.21784 9.50645 0.928403C11.1499 0.621774 12.4194 2.34262 11.6529 3.83135C11.16 4.78706 9.98072 5.151 9.00925 4.70825C8.86024 4.64091 8.73701 4.52341 8.58656 4.4618Z" fill="#3B0764"/>
<path d="M4.49435 8.41646C4.88122 9.02972 5.40851 9.52978 5.92577 10.0298C6.87001 9.24178 8.24411 9.90375 8.14095 11.1518C8.09366 11.7206 7.60076 12.2508 7.02333 12.3038C5.86129 12.4112 5.18069 11.3452 5.69221 10.3178C5.41997 9.97826 5.07322 9.6831 4.78665 9.34494C4.57029 9.0899 4.3697 8.81622 4.18486 8.53539C3.98139 8.52536 3.79799 8.56548 3.58736 8.54828C1.19594 8.34768 1.21887 4.81858 3.48276 4.56783C5.87992 4.30132 6.67371 7.52953 4.49292 8.41646H4.49435Z" fill="#3B0764"/>
<path d="M5.86989 13.953C6.59777 13.9444 7.3056 13.7323 8.00053 13.5389C7.79277 12.533 8.64961 11.7134 9.65117 11.9756C10.7057 12.2522 10.9479 13.675 10.0552 14.304C9.41618 14.7539 8.4791 14.5634 8.13235 13.8555C7.78274 13.9143 7.43169 14.0404 7.07921 14.1135C6.65509 14.2023 6.2281 14.2453 5.80111 14.3141C5.3297 15.5549 3.86963 16.0435 2.74915 15.3013C1.46245 14.4487 1.65875 12.437 3.07154 11.8252C4.53591 11.1904 6.10774 12.3826 5.86989 13.9515V13.953Z" fill="#3B0764"/>
<path d="M14.1231 6.04366C13.3981 6.05943 12.6859 6.26289 11.9924 6.45776C12.2446 7.57538 11.0854 8.45801 10.0681 7.91639C9.34311 7.52953 9.17403 6.55662 9.68842 5.92474C10.2659 5.21548 11.4508 5.31721 11.8606 6.1411C11.9079 6.16832 12.7647 5.91327 12.9138 5.88318C13.3207 5.79865 13.7319 5.75136 14.1446 5.70408C14.2578 5.66826 14.2477 5.5393 14.3022 5.44903C15.7637 3.00173 19.0836 5.04784 17.8556 7.31746C16.8054 9.25754 13.7677 8.22732 14.1231 6.0451V6.04366Z" fill="#3B0764"/>
<path d="M2.70043 9.31915C3.46844 9.2647 3.72205 10.3537 3.00563 10.6245C1.99404 11.0056 1.7089 9.39079 2.70043 9.31915Z" fill="#3B0764"/>
<path d="M17.1765 9.31772C18.2411 9.21312 18.0906 11.0013 17.0131 10.6331C16.3268 10.3995 16.4672 9.38793 17.1765 9.31772Z" fill="#3B0764"/>
<path d="M6.41294 15.9203C7.14942 15.8615 7.43312 16.9003 6.77258 17.2113C5.76529 17.6841 5.37555 16.0019 6.41294 15.9203Z" fill="#3B0764"/>
<path d="M13.4969 15.9203C14.4054 15.8744 14.4354 17.2958 13.5199 17.2901C12.663 17.2858 12.6129 15.9647 13.4969 15.9203Z" fill="#3B0764"/>
</svg>
`, P = "Launch Athena";
function E({ label: n, enabled: e, onClick: i }) {
  const t = n || P, o = e ?? !0;
  return /* @__PURE__ */ C(
    w,
    {
      color: "ai-secondary",
      screenReaderLabel: t,
      title: t,
      size: "medium",
      interaction: o ? "enabled" : "disabled",
      disabled: !o,
      onClick: o ? i : void 0,
      children: /* @__PURE__ */ C(B, { src: U, title: "", description: "", width: "1.25rem", height: "1.25rem" })
    }
  );
}
const Z = "https://studywithathena.com", v = "canvas", D = "/lms-launcher";
function S({
  label: n = "Launch Athena",
  enabled: e,
  learningAgentDomain: i = Z,
  learningAgentPath: t = D,
  lmsPathname: o,
  lmsDomain: l,
  lmsUserId: r,
  lmsSource: a = v,
  lmsHasAthenaUser: s = !1,
  locale: c,
  timezone: h
}) {
  if (!s)
    return null;
  const d = e ?? !0, m = g(
    o,
    l,
    a,
    r,
    s,
    c,
    h
  ), f = M(i, t, m);
  function u(L) {
    L.preventDefault(), window.open(f, "_blank", "noopener");
  }
  return /* @__PURE__ */ C("span", { children: /* @__PURE__ */ C(E, { label: n, enabled: d, onClick: u }) });
}
function k(n) {
  const { currentUserId: e, locale: i, timezone: t, appContext: o } = p(), l = b(typeof window < "u" ? window : void 0);
  return /* @__PURE__ */ C(
    S,
    {
      ...n,
      lmsUserId: n.lmsUserId ?? e,
      lmsSource: n.lmsSource ?? o,
      locale: n.locale ?? i,
      timezone: n.timezone ?? t,
      lmsDomain: n.lmsDomain ?? l.lmsDomain,
      lmsPathname: n.lmsPathname ?? l.lmsPathname
    }
  );
}
export {
  k as LearningAgentLauncher
};
